import request from '@/utils/request'

/**
 * 账号密码登陆
 * https://www.showdoc.com.cn/1003739271891029/10387592071779858
 */
export function loginByPassword(data) {
    return request({
        url: '/api/selection_library/login/account',
        data,
        method: 'post'
    })
}


/**
 * 快捷登陆校验手机要不要填邀请码
 * https://www.showdoc.com.cn/1003739271891029/10387598177106964
 */
export function checkNeedInvitedCode(data) {
    return request({
        url: '/api/selection_library/login/check_need_invite',
        data,
        method: 'post'
    })
}

/**
 * 快捷登陆获取验证码
 * https://www.showdoc.com.cn/1003739271891029/10387602296957530
 */
export function sendSmsCode(data) {
    return request({
        url: '/api/selection_library/login/send_sms',
        data,
        method: 'post'
    })
}


/**
 * 快捷登陆获取邀请码用户id
 * https://www.showdoc.com.cn/1003739271891029/10387608535819254
 */
export function getUserByCode(code) {
    return request({
        url: `/api/selection_library/login/invite/${code}`,
        method: 'get'
    })
}

/**
 * 短信验证码登录
 * https://www.showdoc.com.cn/1003739271891029/10387612202345797
 */
export function longinBySms(data) {
    return request({
        url: '/api/selection_library/login/fast_in',
        data,
        method: 'post'
    })
}


/**
 * 登陆后获取用户信息
 * https://www.showdoc.com.cn/1003739271891029/10387617008486690
 */
export function getUserInfo() {
    return request({
        url: `/api/selection_library/user/info`,
        method: 'get'
    })
}
